export const ReportIcon = ({ width = "28", height = "29" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23 8.86145L23 26.2858"
        stroke="#7647EE"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2881 15.8312L14.2881 26.2858"
        stroke="#7647EE"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.57568 21.0585L5.57568 26.2858"
        stroke="#7647EE"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5 5L17 4.5M20.5 5L19.5 8.5M20.5 5L10.5 11V7L3 12"
        stroke="#7647EE"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
